import React, { FC, useRef, useEffect } from "react";
import {
  IonButton,
  IonModal,
  IonText
} from "@ionic/react";
import './AlertModal.css'
import cn from "classnames";

const AlertModal = props => {
  
  const {isOpen, title, subTitle, buttonText, showCancelButton, onClosed, onConfirm, onCancel } = props;
  
  return (
    <IonModal isOpen={isOpen} className="modal-wrapper" onDidDismiss={onClosed}>
      <div className="modal-content">
        <div className="modal-content-header">
          <IonText className="modal-text">
            {title}
          </IonText>
          {subTitle && (
            <IonText className="modal-sub-text">
              {subTitle}
            </IonText>
          )}
        </div>
        <IonButton
          className={cn('modal-wrapper-button', { 'active': true })}
          onClick={() => {
            onClosed();
            onConfirm && onConfirm();
          }}>
            {buttonText || 'Ok'}
          </IonButton>
        { showCancelButton &&
          <IonButton color="light" 
            onClick={() => {
            onClosed();
            onCancel && onCancel();
          }}>
            {'Cancel'}
          </IonButton>
        }
      </div>
    </IonModal>
  )
}

export default AlertModal
